import { Container } from "./styles";
import Lottie from 'react-lottie';
import animationData from '../../lotties/spinner.json';

export function LoadSpinner() {

    const defaultOptions = {
        loop: true,
        animationData: animationData,
    }

    return (
        <Container>
            <div className='lottie'>
                <div>
                    <Lottie options={defaultOptions} height={200} width={200} />
                </div>
            </div>
        </Container>

    );
}